const index = ({count, text}: {count: string, text: string}) => {
    return (
        <>
            <div className="info-list-item">
                <div className="item-content">
                    <p className="number-info"><span className="count">{ count }</span></p>
                    <p className="info-title">{text}</p>
                </div>
            </div>
        </>
    );
};

export default index;